const it = {
    nav: {
      home: "Home",
      browse: "Esplora Matrimoni",
      dashboard: "Dashboard",
      messages: "Messaggi",
      profile: "Profilo",
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
      admin: "Admin",
      faq: "FAQ",
      about: "Chi siamo",
      contact: "Contatti",
      pricing: "Prezzi",
      howItWorks: "Come funziona",
    },
    auth: {
      login: {
        title: "Bentornato",
        email: "Email",
        password: "Password",
        button: "Accedi",
        noAccount: "Non hai un account?",
        register: "Registrati ora",
      },
      register: {
        title: "Crea account",
        name: "Nome completo",
        email: "Email",
        password: "Password",
        role: "Voglio...",
        roleHost: "Organizzare un matrimonio",
        roleGuest: "Partecipare a matrimoni",
        terms: "Accetto i termini e la privacy policy",
        button: "Registrati",
        hasAccount: "Hai già un account?",
        login: "Accedi ora",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Caricamento...",
      error: "Si è verificato un errore",
      success: "Successo",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
      back: "Indietro",
      next: "Avanti",
      language: "Lingua",
      currency: "Valuta",
      search: "Cerca",
      filter: "Filtra",
      all: "Tutti",
      none: "Nessuno",
      yes: "Sì",
      no: "No",
    },
    footer: {
      about: "Chi siamo",
      privacy: "Privacy",
      terms: "Termini",
      contact: "Contatti",
      copyright: "© 2024 WEDVAYA. Tutti i diritti riservati.",
    },
  };

export default it;
